<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">科室名称</div>
            <el-input v-model="edit_Name" placeholder="请输入科室名称" ></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">状态</div>
            <el-select v-model="edit_status" placeholder="请选择状态" style="width: 100%;">
              <el-option
                  v-for="item in status_arr"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="edit_sort" placeholder="请输入排序" ></el-input>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_Name:'',
      edit_sort:'',
      edit_status:'',
      departmentCode:'',

      status_arr:[{value:1,label:'正常'},{value:2,label:'禁用'}],

    }
  },
  methods: {
    init(row){

      this.edit_Name = row.name;
      this.edit_sort = row.sort;
      this.edit_status = row.status;

      this.departmentCode=row.departmentCode;

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeEdit");
    },

    confirm(){

      if(this.edit_Name === ''){
        this.$message("输入科室名称");
        return;
      }
      if(this.add_sort === ''){
        this.$message("输入排序");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/GovEdit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.edit_Name,
          sort:this.edit_sort,
          status:this.edit_status,
          departmentCode:this.departmentCode,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

